import { DynamicTranslate, getTransCargoType } from '../../../../constants/constants';
import { localDate } from '../../../../utils/date-time-utils';
import {
    stopToLoadingTeamIdLabelTuple,
    stopToOrgLocationIdLabelTuple,
    toDriverDisplayName
} from '../../../../utils/data-mapping-utils';
import { Driver, Load, LoadingTeam, OrganizationLocation, Tractor, Trailer } from '../../../../types';

export const doesValueMatch = (value: string | number, searchText: string) => {
    return value?.toString().toLowerCase().indexOf(searchText?.toLowerCase()) >= 0;
};

export const searchByLoadDate = (load: Load, searchText: string) => {
    return doesValueMatch(localDate(load.date), searchText);
};

export const searchByStopDates = (value: Load, searchText: string) => {
    return value.stops?.some((stop) => {
        return doesValueMatch(localDate(stop.arrivalTime), searchText) ||
            doesValueMatch(localDate(stop.readyTime), searchText) ||
            doesValueMatch(localDate(stop.requiredBegin), searchText) ||
            doesValueMatch(localDate(stop.requiredEnd), searchText);
    })
};

export const searchByStopCargo = (value: Load, searchText: string) => {
    return value.stops?.some((stop) => {
        const cargoTypeLabel = DynamicTranslate(`cargoValue${stop.cargoTypeId}`);

        return doesValueMatch(cargoTypeLabel, searchText)
            || (stop.productionPlan &&doesValueMatch(stop.productionPlan, searchText))
            || (stop.lotId && doesValueMatch(stop.lotId, searchText));
    });
};

export const searchByOrderNumber = (value: Load, searchText: string) => {
    return value.stops?.some((stop) => {
        return stop.orderNumber && doesValueMatch(stop.orderNumber, searchText);
    })
}

export const searchByStopLocation = (value: Load, searchText: string, organizationLocations: OrganizationLocation[] | undefined) => {
    const index = value.stops.map(stopToOrgLocationIdLabelTuple(organizationLocations)).findIndex(s => doesValueMatch(s.siteLabel, searchText));

    return index > -1;
};

export const searchByStopLoadingTeam = (value: Load, searchText: string, loadingTeams: LoadingTeam[] | undefined) => {
    const index = value.stops.map(stopToLoadingTeamIdLabelTuple(loadingTeams)).findIndex(s => doesValueMatch(s.label, searchText));

    return index > -1;
};

export const searchByTractor = (value: Load, searchText: string, tractors: Tractor[] | undefined) => {
    const tractor = tractors?.find(t => t.id === value.tractorId)?.userDisplayName;

    return tractor && doesValueMatch(tractor, searchText);
};

export const searchByTrailer = (value: Load, searchText: string, trailers: Trailer[] | undefined) => {
    const trailer = trailers?.find(t => t.id === value.trailerId)?.userDisplayName;

    return trailer && doesValueMatch(trailer, searchText);
};

export const searchByDriver = (value: Load, searchText: string, drivers: Driver[] | undefined) => {
    const driver = toDriverDisplayName(drivers)(value);

    return doesValueMatch(driver, searchText);
};

export const searchByStopCustomerOrderNumber = (value: Load, searchText: string) => {
    return value.stops?.some((stop) => {
        return stop.customerOrderNumber && doesValueMatch(stop.customerOrderNumber, searchText);
    });
};

export const searchByLoadId = (load: Load, searchText: string) => {
    return doesValueMatch(load.id, searchText);
};

export const searchByStopNotes = (load: Load, searchText: string) => {
    return load.stops?.some((stop) => {
        return stop.notes && doesValueMatch(stop.notes, searchText);
    });
}